import { Component, input } from '@angular/core';
import { NineSlicedSpriteComponent } from '@features/sprites/nine-sliced-sprite/nine-sliced-sprite.component';
import { TSprite } from '@features/styles/sprite-sheet.service';
import { TText } from '@features/styles/styles.service';

@Component({
  selector: 'app-style-sheet-sprite',
  imports: [NineSlicedSpriteComponent],
  templateUrl: './style-sheet-sprite.component.html',
  styleUrl: './style-sheet-sprite.component.css',
})
export class StyleSheetSpriteComponent {
  sprite = input.required<TSprite | undefined>();
  text = input<TText | undefined>();
  borders = input<('TOP' | 'RIGHT' | 'BOTTOM' | 'LEFT')[]>(['TOP', 'RIGHT', 'BOTTOM', 'LEFT']);
}
